import React from 'react';
import LocationTemplate from './LocationTemplate';

const SwanQuarterPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Swan Quarter"
      stateName="North Carolina"
      countyName="Hyde"
      zipCodes={["27885"]}
      latitude={35.4068}
      longitude={-76.3307}
      population={324}
      historicalFact="Incorporated in 1903, Swan Quarter serves as the county seat of Hyde County."
      nearbyTowns={[
        "Engelhard, NC",
        "Fairfield, NC",
        "Scranton, NC",
        "Lake Landing, NC",
        "Ocracoke, NC",
        "Columbia, NC",
        "Plymouth, NC",
        "Washington, NC"
      ]}
    />
  );
};

export default SwanQuarterPage;